export const PRIORITY_DUE_DATE_WORKING_DAYS = {
  high: 3,
  normal: 5,
  low: 7,
} as const;

export const PRIORITY_DUE_DATE_HELP =
  'The due date is set from the priority you choose. High is due in 3 working days, Normal in 5 working days, and Low in 7 working days. Weekends are skipped. If you need the case delivered on or before a particular date, add that date in the description.';

export function dueDateFromPriority(priority: string, from = new Date()): string {
  const days = PRIORITY_DUE_DATE_WORKING_DAYS[priority as keyof typeof PRIORITY_DUE_DATE_WORKING_DAYS] ?? PRIORITY_DUE_DATE_WORKING_DAYS.normal;
  const date = new Date(from.getFullYear(), from.getMonth(), from.getDate());
  let added = 0;
  while (added < days) {
    date.setDate(date.getDate() + 1);
    const day = date.getDay();
    if (day !== 0 && day !== 6) {
      added += 1;
    }
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function formatDueDate(value: string): string {
  if (!value) return '';
  return new Date(`${value.slice(0, 10)}T12:00:00`).toLocaleDateString();
}
